import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle, withStateHandlers } from 'recompose';
import { loadWidgetCMP, changeWidgetJSProp } from '../actions';

import WidgetParams from './WidgetParams';
import FlatButton from 'material-ui/FlatButton/FlatButton';
import { IconButton } from 'material-ui';
import IconDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import IconUp from 'material-ui/svg-icons/hardware/keyboard-arrow-up';

const deprecatedPropTypesScope = p => ['images', 'template'].indexOf(p.scope) >= 0;
const mainFilter = p => p.required && !deprecatedPropTypesScope(p) && ['dnd'].indexOf(p.key) === -1;

const uiFilter = p =>
    (p.ui || p.loader) && !p.scope && !p.required && !deprecatedPropTypesScope(p) && ['dnd'].indexOf(p.key) === -1;

const filterRequired = p => (p.required || p.loader) && !deprecatedPropTypesScope(p);
const filterOptions = p => p.ui && !deprecatedPropTypesScope(p);

const advancedFilter = p => {
    return p.scope === 'template';
};

const commonFilter = p => {
    return p.scope === 'common';
};
function WidgetDataManipulations({ title, filter = mainFilter, scope = 'all', expandEditor, expanded, ...props }) {
    return (
        <div>
            {/* {JSON.stringify(props.params)} */}
            <h4
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '0px -12px 0 -12px',
                    padding: '6px 12px',
                    background: '#333',
                    fontSize: 18,
                    fontWeight: 500,
                    borderBottom: '1px solid #444',
                }}
            >
                <div style={{ flexGrow: 1 }}>{title}</div>
                <IconButton
                    onClick={() => {
                        expandEditor(!expanded);
                    }}
                >
                    {!expanded ? <IconDown /> : <IconUp />}
                </IconButton>
            </h4>

            {expanded && (
                <div>
                    <WidgetParams widgetId={props.params && props.params.widgetId} filter={filter} />
                    <div style={{ height: 10 }} />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = { loadWidgetCMP, changeWidgetJSProp };

export { advancedFilter, commonFilter, uiFilter };
export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    withStateHandlers(
        props => ({
            expanded: props.expanded || false,
        }),
        {
            expandEditor: () => expanded => ({ expanded }),
        },
    ),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {},
    }),
)(WidgetDataManipulations);



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/WidgetDataManipulations.js
 **/